export default __webpack_public_path__ + "static/media/virtual ideate 2.768bd231.jpg";